import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { setupI18n, storedLocale, storedTheme } from '@rootsight/shared';
import { applyTheme } from '@rootsight/ui';

import en from './locales/en.json';
import he from './locales/he.json';
import securityEn from './locales/security/en.json';
import securityHe from './locales/security/he.json';
import { router } from './router';
import '@rootsight/ui/styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Nothing on the login screen benefits from background refetching.
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

// Paint in the operator's chosen mode from the first frame.
applyTheme(storedTheme());

async function bootstrap() {
  // i18n is initialized before the first render so no English text flashes
  // before a Hebrew operator's locale is applied.
  const i18n = await setupI18n({
    defaultNS: 'auth',
    locale: storedLocale(),
    resources: {
      en: { auth: en, security: securityEn },
      he: { auth: he, security: securityHe },
    },
  });

  const container = document.getElementById('root');
  if (!container) throw new Error('#root is missing from index.html');

  createRoot(container).render(
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </I18nextProvider>
    </StrictMode>,
  );
}

void bootstrap();
